import styled from 'styled-components';
import { Dropdown, ToggleButton } from 'react-bootstrap';
import * as React from 'react';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import clsx from 'clsx';
import { GridFullRow } from '../Grid';
import { Input } from '../Input';
import { NoneButton } from '../AttachmentTag';
import { scenesLedColors } from '../../util';

export const ConfiguratorColumnTitle = styled.p`
  font-size: 20px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const ConfiguratorColumnLabel = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.font3};
  margin-bottom: 40px;
`;

export const DevicesListToggleContainer = styled(GridFullRow)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.font1};
`;

export const DevicesListToggleButton = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.colors.background3};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;
`;

export const DragDropInfoSceneContainer = styled.div<{
  devicesListCollapsed: boolean;
  noActions: boolean;
}>`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  user-select: none;
  border: ${({ theme }) => `2px dashed ${theme.colors.background3}`};
  padding: 184px 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.background2};
  opacity: ${({ noActions }) => (noActions ? 100 : 0.95)};
  z-index: 9;

  ${({ theme }) => theme.mediaQueries.small} {
    display: ${({ devicesListCollapsed, noActions }) =>
      !devicesListCollapsed || noActions ? 'flex' : 'none'};
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    display: ${({ noActions }) => (noActions ? 'flex' : 'none')};
  }
`;

export const SceneCreateParagraph = styled.p`
  color: ${({ theme }) => theme.colors.font3};
  font-size: 14px;
  margin-top: 32px;
  overflow: hidden;
`;

export const DeviceItemTileWrapper = styled.div`
  width: 100%;
  padding-bottom: 16px;
  flex-basis: 50%;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.small} {
    flex-basis: 100%;
  }
  ${({ theme }) => theme.mediaQueries.medium} {
    flex-basis: 50%;

    &:nth-child(odd) {
      padding-right: 8px;
    }
  }
`;

export const SceneActionDetailsWrapper = styled.div`
  flex: 0 0 155px;
  display: flex;
  align-items: center;
`;

export const DevicesFilterButton = styled.button`
  background-color: ${({ theme }) => theme.colors.background3};
  width: 34px;
  height: 34px;
  margin-left: 13px;
  border: none;
`;

export const DevicesFilterDropdown = styled(Dropdown.Menu)`
  min-width: 224px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.background2};
`;

export const RemoveActionButton = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background3};
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: none;
  border: none;

  svg {
    width: 11px;
    height: 11px;

    path {
      fill: ${({ theme }) => theme.colors.background};
    }
  }
`;

export const DeviceItemTitle = styled.p`
  color: ${({ theme }) => theme.colors.font1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const DeviceItemLabel = styled.p`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.font3};
  margin: 0;
`;

export const ToggleGroupBtn: any = styled(ToggleButton)`
  background-color: ${({ theme }) => theme.colors.background3} !important;

  &.active {
    background-color: white !important;
  }
`;

export const DeviceItemTileContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background3};
  padding: 8px 6px;
  display: flex;
  align-items: center;
  font-size: 11px;
  user-select: none;
`;

export const SceneActionParamContainer = styled.div`
  height: 48px;
  background-color: ${({ theme }) => `${theme.colors.background3}90`};
  align-items: center;
  display: flex;
  width: 100%;

  button {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ColorSelectorActiveBtn = styled(NoneButton)`
  &.color-circle-active {
    height: 100%;
    background-color: ${({ theme }) => theme.colors.background3}!important;
    display: flex;
    align-items: center;
    justify-content: center;

    .create-scene-action-item-color-circle {
      opacity: 1;
    }
  }
`;

export const CreateSceneDragAreaInfo = styled.div<{ clickable?: boolean }>`
  height: 56px;
  background-color: ${({ theme }) => theme.colors.background3};
  border: ${({ theme }) => `1px dashed ${theme.colors.background}`};
  color: ${({ theme }) => theme.colors.font3};
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  user-select: none;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const SceneActionColorSliderContainer = styled.div`
  height: 48px;
  width: 150px;
  background-color: ${({ theme }) => `${theme.colors.background3}90`};
  display: flex;
  align-items: center;
  padding: 0 8px;
`;

export const SearchInput = styled(Input)`
  flex: 1;

  input {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.background3};
    color: ${({ theme }) => theme.colors.font3};
    border: none;
  }
`;

export const DevicesPanel = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.small} {
    grid-column: span 3;
  }
  ${({ theme }) => theme.mediaQueries.medium} {
    grid-column: span 4;
  }
`;

export const CreatorPanel = styled.div<{ devicesListCollapsed?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${({ theme }) => theme.mediaQueries.small} {
    grid-column: ${({ devicesListCollapsed }) =>
      `span ${devicesListCollapsed ? 8 : 5}`};
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    grid-column: ${({ devicesListCollapsed }) =>
      `span ${devicesListCollapsed ? 12 : 8}`};
  }
`;

export const ActionParamWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
`;

export const ColorDropdownToggle = React.forwardRef(
  (
    buttonProps: {
      onClick: (event) => void;
      Color: { hue: string; saturation: string };
    },
    buttonRef
  ) => {
    const { onClick, Color } = buttonProps;
    const { hue, saturation } = Color;
    const colorName = Object.keys(scenesLedColors).find(color => {
      const colorValue = scenesLedColors[color];
      return colorValue.hue === hue && colorValue.saturation === saturation;
    });

    return (
      <ColorSelectorActiveBtn
        type="button"
        // @ts-ignore
        ref={buttonRef}
        onClick={event => {
          event.preventDefault();
          onClick(event);
        }}
      >
        <div
          className={`create-scene-action-item-color-circle create-scene-action-item-color-circle--${colorName}`}
        />
      </ColorSelectorActiveBtn>
    );
  }
);

const ColorSelectorContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const ColorSelector = props => {
  const { actionParameters, setLedColor, className } = props;

  return (
    <ColorSelectorContainer className={className}>
      {Object.keys(scenesLedColors).map(colorName => {
        return (
          <ColorSelectorActiveBtn
            type="button"
            className={clsx({
              'color-circle-active':
                actionParameters.Color.hue === scenesLedColors[colorName].hue &&
                actionParameters.Color.saturation ===
                  scenesLedColors[colorName].saturation
            })}
            onClick={() =>
              setLedColor(actionParameters, scenesLedColors[colorName])
            }
          >
            <div
              className={`create-scene-action-item-color-circle create-scene-action-item-color-circle--${colorName}`}
            />
          </ColorSelectorActiveBtn>
        );
      })}
    </ColorSelectorContainer>
  );
};

const ColorDropdown = styled(DropdownMenu)`
  display: flex !important;
  height: 48px;
  background-color: ${({ theme }) => theme.colors.background2};
  padding: 0;
`;

const DropdownColor = (props: any) => {
  const { actionParameters, setLedColor, className } = props;

  return (
    <Dropdown data-testid="select-color-dropdown" className={className}>
      <Dropdown.Toggle
        Color={actionParameters.Color}
        as={ColorDropdownToggle}
      />
      <ColorDropdown>
        <ColorSelector
          setLedColor={setLedColor}
          actionParameters={actionParameters}
        />
      </ColorDropdown>
    </Dropdown>
  );
};

export const DropdownColorSelector = styled(DropdownColor)`
  ${({ theme }) => theme.mediaQueries.medium} {
    display: flex;
  }
  ${({ theme }) => theme.mediaQueries.large} {
    display: none;
  }
`;

export const InlineColorSelector = styled(ColorSelector)`
  ${({ theme }) => theme.mediaQueries.medium} {
    display: none;
  }
  ${({ theme }) => theme.mediaQueries.large} {
    display: flex;
  }
`;
